// Full Shopify JavaScript for Wishlist functionality (assets/wishlist.js)

// Initialize wishlist from localStorage if customer is not logged in
// Bootstrap wishlist differently for guests vs. logged-in customers
let wishlist = [];

if (window.customerId && window.customerId !== "null") {
  // Logged-in → trust the server array injected in theme.liquid
  wishlist = Array.isArray(window.customerWishlist)
    ? [...window.customerWishlist]
    : [];
} else {
  // Guest → fall back to localStorage
  wishlist = JSON.parse(localStorage.getItem("wishlist") || "[]");
}

// Persist to localStorage only when the visitor is NOT logged in
function persistGuestWishlist() {
  if (!window.customerId || window.customerId === "null") {
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
  }
}


// Function to add product to local wishlist and handle logged-in users
function addWishlistProduct(productHandle) {
  console.log(
    "addWishlistProduct function started with productHandle:",
    productHandle
  );

  if (!wishlist.includes(productHandle)) {
    wishlist.push(productHandle);
    persistGuestWishlist();


    if (window.customerId && window.customerId !== "null") {
      updateWishlistButtonStateLoggedIn(productHandle); // Update button state for logged-in users
    } else {
      updateWishlistButtonState(productHandle); // Update button state for logged-out users
    }


    updateWishlistCountFrontend(1); // Increment the count immediately for front-end

    // Send wishlist add event to GA4
    if (typeof gtag === 'function') { // Check if gtag is defined
        gtag('event', 'add_to_wishlist', {
        item_name: productHandle,
        currency: Shopify.currency.active
        });
    }


  } else {
    // Product is already in wishlist, do nothing here
    return;
  }

  // Check if the customer is logged in using window.customerId
  console.log("Attempting customer check:", window.customerId);
  if (window.customerId && window.customerId !== "null") {
    console.log(
      "Customer is logged in. Adding product to wishlist for customerId:",
      window.customerId
    );
    addToWishlistBackend(window.customerId, productHandle);
  } else {
    console.warn("Customer is not logged in, adding product to local storage.");
    // Product already added to local wishlist above
  }
}

// Function to remove product from wishlist
function removeFromWishlist(productHandle) {
  const index = wishlist.indexOf(productHandle);
  if (index > -1) {
    wishlist.splice(index, 1);
    persistGuestWishlist();      // save only for guests


    if (window.customerId && window.customerId !== "null") {
      updateWishlistButtonStateLoggedIn(productHandle); // Update button state for logged-in users
    } else {
      updateWishlistButtonState(productHandle); // Update button state for logged-out users
    }

    updateWishlistCountFrontend(-1); // Decrement the count immediately for front-end

    // Remove the item from the wishlist page list if it exists
    const wishlistItemElement = document.querySelector(`.wishlist-item[data-product-handle="${productHandle}"]`);
    if (wishlistItemElement) {
      console.log("wishlistItemElement: ", wishlistItemElement);
      wishlistItemElement.style.display = 'none'; // Hide the item immediately
    }

    // Remove the server-rendered product card for logged-in users
    if (window.customerId && window.customerId !== "null") {
      const serverRenderedWishlistItem = document.querySelector(`.wishlist-page-wrapper .gs-collection-card-wrapper.gs-${productHandle}`);
      if (serverRenderedWishlistItem) {
          console.log("wishlistItemElement Logged In: ", serverRenderedWishlistItem);
        serverRenderedWishlistItem.style.display = 'none'; // Hide the server-rendered product card
      }
    }

    // Send wishlist remove event to GA4
    if (typeof gtag === 'function') { // Check if gtag is defined
        gtag('event', 'remove_from_wishlist', {
        item_name: productHandle,
        currency: Shopify.currency.active
        });
    }
  }

  // Check if customer is logged in
  if (window.customerId && window.customerId !== "null") {
    console.log(
      "Customer is logged in. Removing product from wishlist for customerId:",
      window.customerId
    );
    removeFromWishlistBackend(window.customerId, productHandle);
  }
}


// Function to render wishlist items on the page
function renderWishlistItems(productHandles) {
  const wishlistContainer = document.getElementById("wishlist-items");
  if (!wishlistContainer) {
    // console.error("Error: Could not find wishlist container on the page."); // It's ok if not on wishlist page
    return;
  }

  if (productHandles.length === 0) {
    wishlistContainer.innerHTML = "<p>Your wishlist is empty.</p>";
    updateWishlistCount();
  } else {
    wishlistContainer.innerHTML = "";
    let unavailableProducts = [];
    let fetchPromises = [];

    productHandles.forEach((productHandle) => {
      console.log("Fetching details for product handle:", productHandle);

      // Fetch product details using Ajax API
      const fetchPromise = fetch(`/products/${productHandle.trim()}.js`)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Product not found: " + productHandle);
          }
          return response.json();
        })
        .then((product) => {
          console.log("Fetched product details:", product);
          const formattedPrice = (product.price / 100).toLocaleString(undefined, { style: 'currency', currency: Shopify.currency.active });
          const formattedCompareAtPrice = product.compare_at_price ? (product.compare_at_price / 100).toLocaleString(undefined, { style: 'currency', currency: Shopify.currency.active }) : '';

          const wishlistItem = document.createElement('div');
          wishlistItem.classList.add('wishlist-item');
          wishlistItem.setAttribute('data-product-handle', product.handle);

          wishlistItem.innerHTML = `
            <a class="wishlist-link-gs" href="/products/${product.handle}">
              <img src="${product.images && product.images.length > 0 ? product.images[0] : '//via.placeholder.com/100'}" alt="${product.title}" />
              <div class="product-title-wish product-title h6">${product.title}</div>
              <div class="price h6 text-subdued">
                ${product.price ? `<span class="price-item">${formattedPrice}</span>` : ''}
                ${product.compare_at_price > product.price ? `<s class="compare-price">${formattedCompareAtPrice}</s>` : ''}
              </div>
            </a>
            <button class="remove-from-wishlist">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                <title>Close</title>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Close">
                    <rect id="Rectangle" fill-rule="nonzero" x="0" y="0" width="24" height="24"></rect>
                    <line x1="16.9999" y1="7" x2="7.00001" y2="16.9999" id="Path" stroke="#0C0310" stroke-width="2" stroke-linecap="round"></line>
                    <line x1="7.00006" y1="7" x2="17" y2="16.9999" id="Path" stroke="#0C0310" stroke-width="2" stroke-linecap="round"></line>
                  </g>
                </g>
              </svg>
            </button>
          `;

          const removeButton = wishlistItem.querySelector('.remove-from-wishlist');
          removeButton.addEventListener('click', (event) => {
              event.stopPropagation();
              removeFromWishlist(product.handle);
          });

          wishlistContainer.appendChild(wishlistItem);
      })
      .catch((error) => {
          console.error("Failed to fetch product details for wishlist item:", error);
          // Mark product as unavailable
          unavailableProducts.push(productHandle.trim());
      });

      fetchPromises.push(fetchPromise);
    });

    // After all fetches complete, clean up unavailable products
    Promise.allSettled(fetchPromises).then(() => {
      if (unavailableProducts.length > 0) {
        console.log("Cleaning up unavailable products:", unavailableProducts);
        
        // Remove from wishlist array
        unavailableProducts.forEach(handle => {
          const index = wishlist.indexOf(handle);
          if (index > -1) {
            wishlist.splice(index, 1);
          }
        });

        // Persist changes
        persistGuestWishlist();
        
        // If logged in, batch remove from server
        if (window.customerId && window.customerId !== "null") {
          unavailableProducts.forEach(handle => {
            fetch("https://addtowishlist-lacomet-94056801023.us-central1.run.app", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                customerId: window.customerId,
                productHandle: handle,
              }),
            }).catch((err) => console.error("Failed to remove unavailable product from server:", err));
          });
        }

        // Update the count
        updateWishlistCount();
      }
    });
  }
}

// Function to display the confirmation popup
function displayWishlistConfirmationPopup(buttonElement) {
  const existingPopup = document.querySelector(".wishlist-popup");
  if (existingPopup) {
    existingPopup.remove();
  }

  const isLoggedIn = window.customerId && window.customerId !== "null";
  let popupHTML = '';
  let shouldDisplay = false;

  if (isLoggedIn && buttonElement.classList.contains("active-wishlist-new")) {
    shouldDisplay = true;
    popupHTML = `
      <div class="current-inner-wrapper">
        <div class="wishlist-popup-content">
          <h3>${window.wishlistPopupSettings.loggedInTitle || "Added to Wishlist"}</h3>
          <span class="seperator-wish"></span>
          <p>${window.wishlistPopupSettings.loggedInText || "You can view your wishlist anytime."}</p>
          <a href="${window.wishlistPopupSettings.loggedInCTAUrl || "/pages/wishlist"}"><button class="button wishlist-popup-button">${window.wishlistPopupSettings.loggedInCTA || "View Wishlist"}</button></a>
        </div>
        <button class="close-button">×</button>
      </div>`;
  } else if (!isLoggedIn && buttonElement.classList.contains("active-wishlist")) {
    shouldDisplay = true;
    popupHTML = `
      <div class="current-inner-wrapper">
        <div class="wishlist-popup-content">
          <h3>${window.wishlistPopupSettings.loggedOutTitle || "Added to Wishlist"}</h3>
          <span class="seperator-wish"></span>
          <p>${window.wishlistPopupSettings.loggedOutText || "Log in to save your wishlist permanently."}</p>
          <a href="${window.wishlistPopupSettings.loggedOutCTAUrl || "/account/login"}" class="button wishlist-popup-button">${window.wishlistPopupSettings.loggedOutCTA || "Log In"}</a>
        </div>
        <button class="close-button">×</button>
      </div>`;
  }

  if (!shouldDisplay) {
    return;
  }

  const wishlistPopup = document.createElement("div");
  wishlistPopup.classList.add("wishlist-popup");
  wishlistPopup.innerHTML = popupHTML;

  if (window.innerWidth < 767) {
    document.body.appendChild(wishlistPopup);
  } else {
    buttonElement.parentNode.insertBefore(wishlistPopup, buttonElement.nextSibling);
  }

  const closePopupButton = wishlistPopup.querySelector(".close-button");
  closePopupButton.addEventListener("click", () => {
    wishlistPopup.remove();
    document.removeEventListener("click", handleClickOutside);
  });

  const handleClickOutside = (event) => {
    if (!wishlistPopup.contains(event.target) && !buttonElement.contains(event.target)) {
      wishlistPopup.remove();
      document.removeEventListener("click", handleClickOutside);
    }
  };
  setTimeout(() => {
    document.addEventListener("click", handleClickOutside);
  }, 0);

  setTimeout(() => {
    if (wishlistPopup.parentNode) {
        wishlistPopup.remove();
    }
    document.removeEventListener("click", handleClickOutside);
  }, 6000);
}

// Function to initialize event listeners for wishlist buttons
function initializeWishlistButtonEventListeners() {
  console.log("Wishlist.js: Initializing wishlist button event listeners...");
  const addToWishlistButtons = document.querySelectorAll(".add-to-wishlist-button");
  console.log(`Wishlist.js: Found ${addToWishlistButtons.length} '.add-to-wishlist-button' elements.`);


  addToWishlistButtons.forEach((button) => {
    if (button.dataset.wishlistListenerAttached === "true") {
      const productHandle = button.getAttribute("data-product-handle");
      if (productHandle) {
        if (window.customerId && window.customerId !== "null") {
            updateWishlistButtonStateLoggedIn(productHandle);
        } else {
            updateWishlistButtonState(productHandle);
        }
      }
      return;
    }
    button.dataset.wishlistListenerAttached = "true";

    const productHandle = button.getAttribute("data-product-handle");

    if (productHandle) {
        if (wishlist.includes(productHandle)) {
            if (window.customerId && window.customerId !== "null") {
                button.classList.add("active-wishlist-new");
            } else {
                button.classList.add("active-wishlist");
            }
        } else {
            button.classList.remove("active-wishlist-new");
            button.classList.remove("active-wishlist");
        }
    } else {
        console.warn("Wishlist.js: Button found without data-product-handle:", button);
    }

    button.addEventListener("click", function(event) {
      event.stopPropagation();
      const currentProductHandle = this.getAttribute("data-product-handle"); // Get handle at time of click
      if (currentProductHandle) {
        const isCurrentlyInWishlist = wishlist.includes(currentProductHandle);
        if (isCurrentlyInWishlist) {
          removeFromWishlist(currentProductHandle);
        } else {
          addWishlistProduct(currentProductHandle);
          displayWishlistConfirmationPopup(this);
        }
      } else {
        console.error("Wishlist.js: Error: productHandle is not defined or null for button:", this);
      }
    });
  });
}

// --- THIS IS THE PRIMARY DOMContentLoaded LISTENER ---
document.addEventListener("DOMContentLoaded", () => {
  console.log("Wishlist.js: DOMContentLoaded fired. Initializing all wishlist components.");
  initializeWishlistButtonEventListeners(); // Initialize buttons across the site

  const wishlistContainer = document.getElementById("wishlist-items");
  if (wishlistContainer) {
    console.log("Wishlist.js: Wishlist container found. Rendering wishlist items…");
    if (wishlist.length === 0) {
      renderEmptyWishlist();
    } else {
      renderWishlistItems(wishlist);
    }
  }

  updateWishlistCount(); // Update wishlist count on page load
});
// --- END OF PRIMARY DOMContentLoaded LISTENER ---


// Function to render empty wishlist message
function renderEmptyWishlist() {
  const wishlistContainer = document.getElementById("wishlist-items");
  if (!wishlistContainer) {
    // console.error("Error: Could not find wishlist container on the page."); // OK if not on wishlist page
    return;
  }
  wishlistContainer.innerHTML = "<p>Your wishlist is empty.</p>";
}

// Function to add product to wishlist by sending data to backend (Google Cloud Function)
function addToWishlistBackend(customerId, productHandle) {
  const url = "https://addtowishlist-lacomet-94056801023.us-central1.run.app";
  console.log("Sending request to backend with customerId and productHandle:", { customerId, productHandle });
  fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ customerId, productHandle }),
  })
    .then((response) => response.json())
    .then((data) => { console.log("Wishlist updated on backend:", data); })
    .catch((error) => { console.error("Failed to update wishlist on backend:", error); });
}

// Function to remove product from wishlist by sending data to backend (Google Cloud Function)
function removeFromWishlistBackend(customerId, productHandle) {
  const url = "https://removefromwishlist-lacomet-94056801023.us-central1.run.app";
  console.log("Sending request to backend to remove product with customerId and productHandle:", { customerId, productHandle });
  fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ customerId, productHandle }),
  })
    .then((response) => response.json())
    .then((data) => { console.log("Wishlist updated on backend after removal:", data); })
    .catch((error) => { console.error("Failed to update wishlist on backend after removal:", error); });
}

// Function to update the wishlist count in the header immediately for the front-end
function updateWishlistCountFrontend(change) {
  const wishlistCountElement = document.getElementById("wishlist-count");
  if (!wishlistCountElement) {
    // console.error("Error: Could not find wishlist count element on the page."); // OK if theme doesn't have it
    return;
  }
  const currentCount = parseInt(wishlistCountElement.textContent) || 0;
  const newCount = Math.max(0, currentCount + change); // Ensure count doesn't go below 0
  wishlistCountElement.textContent = newCount > 0 ? newCount : "";
  wishlistCountElement.style.display = newCount > 0 ? "inline" : "none";
}

// Function to update the wishlist count in the header
function updateWishlistCount() {
  const wishlistCountElement = document.getElementById("wishlist-count");
  if (!wishlistCountElement) {
    return;
  }

  if (window.customerId && window.customerId !== "null") {
    console.log("Customer is logged in. Fetching wishlist count from backend for customerId:", window.customerId);
    const url = "https://getwishlist-lacomet-94056801023.us-central1.run.app";
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ customerId: window.customerId }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Fetched wishlist count from backend:", data);
        const count = data.count || (Array.isArray(data.wishlist) ? data.wishlist.length : 0); // Adapt to backend response
        wishlistCountElement.textContent = count > 0 ? count : "";
        wishlistCountElement.style.display = count > 0 ? "inline" : "none";
      })
      .catch((error) => { console.error("Failed to fetch wishlist count from backend:", error); });
  } else {
    console.log("Guest visitor. Using in-memory wishlist array for count.");
    wishlistCountElement.textContent = wishlist.length > 0 ? wishlist.length : "";
    wishlistCountElement.style.display = wishlist.length > 0 ? "inline" : "none";
  }
}

// Function to update the wishlist button state
function updateWishlistButtonState(productHandle) {
  const buttons = document.querySelectorAll(`.add-to-wishlist-button[data-product-handle="${productHandle}"]`);
  buttons.forEach((button) => {
    if (wishlist.includes(productHandle)) {
      button.classList.add("active-wishlist");
      button.classList.remove("active-wishlist-new"); // Ensure only one active state
    } else {
      button.classList.remove("active-wishlist");
    }
  });
}

// Function to update the wishlist button state for logged-in users
function updateWishlistButtonStateLoggedIn(productHandle) {
  const buttons = document.querySelectorAll(`.add-to-wishlist-button[data-product-handle="${productHandle}"]`);
  buttons.forEach((button) => {
    if (wishlist.includes(productHandle)) {
      button.classList.add("active-wishlist-new");
      button.classList.remove("active-wishlist"); // Ensure only one active state
    } else {
      button.classList.remove("active-wishlist-new");
    }
  });
}

// NOTE: The last document.addEventListener("DOMContentLoaded") block that was
// solely for popups has been REMOVED as its functionality is now handled by
// initializeWishlistButtonEventListeners calling displayWishlistConfirmationPopup.

// The very first document.addEventListener("DOMContentLoaded") block that was
// also initializing buttons has also been REMOVED for the same reason.
// The one remaining DOMContentLoaded listener above is now the primary initializer.